var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"agreement"},[_c('i',{staticClass:"iconfont select",class:{
        'icon-weigouxuan':
          this.$store.state.commonForms.agreeWithAgreement === 0,
        'icon-gouxuanxieyi-icon- seletedColor':
          this.$store.state.commonForms.agreeWithAgreement === 1,
      },on:{"click":function($event){return _vm.clickAgree()}}}),_c('span',{on:{"click":function($event){return _vm.clickAgree()}}},[_vm._v("本人已经阅读并完全同意：")]),_vm._l((_vm.list),function(item){return _c('span',{key:item.value,on:{"click":function($event){return _vm.show(item.value)}}},[_vm._v("《"+_vm._s(item.text)+"》")])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }